document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.btn-caramella-ajax-fetch').forEach(function (button) {
		var triggerEvent = button.getAttribute('data-event') || 'click';

		button.addEventListener(triggerEvent, function () {
			var targetSelector = button.getAttribute('data-target');
			var sourceSelector = button.getAttribute('data-source');
			var action = button.getAttribute('data-action');
			var async = button.getAttribute('data-async') ?? 'restapi';
			var funcName = button.getAttribute('data-function');
			var sourceElement = document.querySelector(sourceSelector);
			var allowedExtensions = sourceElement && sourceElement.getAttribute('data-allowed-extensions') ? sourceElement.getAttribute('data-allowed-extensions').split(',') : [];

			if (!targetSelector || !sourceSelector || !action || !funcName) {
				console.error('Undefined variable:',
					!targetSelector ? 'targetSelector' : '',
					!sourceSelector ? 'sourceSelector' : '',
					!action ? 'action' : '',
					!funcName ? 'funcName' : '');
				return;
			}

			var formData = new FormData();
			formData.append('action', action);

			// source element to formdata
			Object.entries(sourceElement.dataset).forEach(([key, value]) => {
				formData.append(key, value);
			});

			// button element to formdata
			Object.entries(button.dataset).forEach(([key, value]) => {
				formData.append(key, value);
			});

			// form fields to formdata
			sourceElement.querySelectorAll('.formdata-formfield').forEach(function (element) {
				if (element.type === 'checkbox' || element.type === 'radio') {
					if (element.checked) {
						formData.append(element.name, element.value);
					}
				} else if (element.tagName === 'SELECT' && element.multiple) {
					// For multi-select
					Array.from(element.selectedOptions).forEach(option => {
						formData.append(element.name, option.value);
					});
				} else {
					formData.append(element.name, element.value);
				}
			});

			// file uploads to formdata
			sourceElement.querySelectorAll('.formdata-upload').forEach(function (input) {
				Array.from(input.files).forEach(function (file, index) {
					var fileExtension = file.name.split('.').pop().toLowerCase();
					if (allowedExtensions.length === 0 || allowedExtensions.includes(fileExtension)) {
						formData.append('file_' + index, file);
					} else {
						console.error('File extension not allowed: ' + file.name);
					}
				});
			});

			var endpoint = caramella.rest_url + 'caramella-api/v1/' + action + '/';
			if (async == 'ajaxapi') {
				endpoint = caramella.ajax_url;
			}

			button.disabled = true; // Disable button before the fetch call
			button.setAttribute('disabled', 'true');

			fetch(endpoint, {
				method: 'POST',
				headers: {
					'X-WP-Nonce': caramella.nonce
				},
				body: formData
			})
				.then(response => response.json())
				.then(response => {
					if (typeof window[funcName] === 'function') {
						window[funcName](response, targetSelector);
					} else {
						console.error('Function ' + funcName + ' is not defined.');
					}
				})
				.catch(error => console.error('Fetch error:', error))
				.finally(() => {
					button.disabled = false; // Re-enable button after the fetch is complete
					button.removeAttribute('disabled');
				});
		});
	});
});

/* HTML EXAMPLE

<button class="btn-caramella-ajax-fetch btn btn-success w-100 mb-5" 
        data-target="#targetElement" 
        data-source="#sourceElement" 
        data-action="caramella_debug_data" 
        data-function="ajaxCallbackTest">
    Click Me (wp-json)
</button>

<button class="btn-caramella-ajax-fetch btn btn-success w-100 mb-5" 
        data-target="#targetElement" 
        data-source="#sourceElement" 
        data-async="ajaxapi" 
        data-action="caramella_debug_data" 
        data-function="ajaxCallbackTest">
    Click Me (admin-ajax)
</button>

<div id="sourceElement" class="alert alert-warning text-center" 
     data-custom-attribute1="value1" 
     data-custom-attribute2="value2"
     data-allowed-extensions="jpg,png,docx">
    <span id="targetElement" class="badge text-bg-danger">
        This will disappear when successful
        <hr />
        <!-- File Input for attachments -->
            <input type="file" class="formdata-upload" name="fileAttachment1" />
            <input type="file" class="formdata-upload" name="fileAttachment2" multiple />
            <input class="formdata-formfield" type="text" name="textForm" />
    </span>
</div>


 */
